import { createApp } from 'vue'
import { createHead } from '@unhead/vue/client'
import App from './App.vue'
import 'bootstrap/dist/css/bootstrap.css'
import bootsratp from 'bootstrap/dist/js/bootstrap.bundle.js';
import '@/assets/scss/style.scss';
import '@/assets/libs/@iconscout/unicons/css/line.css';
import '@/assets/libs/@mdi/font/css/materialdesignicons.min.css'
import router from './router'
import AOS from 'aos'
import 'aos/dist/aos.css'

const app = createApp(App)
const head = createHead()
app.use(router)
app.use(bootsratp)
app.use(head)
app.mount('#app')

AOS.init({
  once: true,        // animate only once
  offset: 120,       // trigger offset (in px)
  duration: 600,     // animation duration in ms
})